import React from 'react';
import PropTypes from 'prop-types';
export default (function (_ref) {
  var Provider = _ref.Provider;
  var TextStore = function TextStore(_ref2) {
    var value = _ref2.value,
      _ref2$params = _ref2.params,
      params = _ref2$params === void 0 ? {} : _ref2$params,
      _ref2$children = _ref2.children,
      children = _ref2$children === void 0 ? null : _ref2$children,
      _ref2$resolvers = _ref2.resolvers,
      resolvers = _ref2$resolvers === void 0 ? {} : _ref2$resolvers,
      _ref2$transformers = _ref2.transformers,
      transformers = _ref2$transformers === void 0 ? {} : _ref2$transformers;
    return /*#__PURE__*/React.createElement(Provider, {
      value: {
        value: value,
        params: params,
        resolvers: resolvers,
        transformers: transformers
      }
    }, children);
  };
  TextStore.propTypes = {
    value: PropTypes.shape({}).isRequired,
    params: PropTypes.shape({}),
    // eslint-disable-line react/require-default-props
    children: PropTypes.node,
    // eslint-disable-line react/require-default-props
    resolvers: PropTypes.objectOf(PropTypes.func),
    // eslint-disable-line react/require-default-props
    transformers: PropTypes.objectOf(PropTypes.func) // eslint-disable-line react/require-default-props
  };
  return TextStore;
});